import { Component } from '@angular/core';

@Component({
  selector: 'app-payment-policy',
  templateUrl: './payment-policy.component.html',
  styleUrls: ['./payment-policy.component.css'],
  standalone: false
})
export class PaymentPolicyComponent {}
